// extracted by mini-css-extract-plugin
export default {"container":"H2_container__fTc9p"};